import { useEffect, useState } from "react";
import { IConfirmAccountsFormProps } from "../../interfaces/account/signup";
import { toast } from "react-toastify";
import { IError } from "../../interfaces/user/errors";
import { AppDispatch } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { confirmAccount } from "../../data-access/apis/authentication/auth";
import { useNavigate } from "react-router-dom";
import { resetAuth } from "../../stores/auth-slice";

// Default form values
const confirmAccountFormProps: IConfirmAccountsFormProps = {
  contact: '',
  otp: '',
  phone: '',
};

export const ConfirmAccountHelper = () => {
  const [values, setValues] = useState<IConfirmAccountsFormProps>(confirmAccountFormProps);
  const [formErrors, setFormErrors] = useState<IError[]>([]);
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const account = useSelector((state: any) => state.auth);
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate(); // Initialize navigate from useNavigate


  // Helper function to validate contact information (email, username, or phone)
  const validateContactInfo = (contact: string): IError | null => {
    const isEmailValid = /\S+@\S+\.\S+/.test(contact);
    const isPhoneValid = /^[0-9]{10}$/.test(contact);

    if (contact.trim() === '') {
      return { field: 'contact', message: 'Please provide either email, username, or phone number.' };
    } else if (isEmailValid || isPhoneValid) {
      // No error if either valid email or phone
      return null;
    } else {
      return { field: 'contact', message: 'Please enter a valid email address or phone number.' };
    }
  };

  // Helper function to validate OTP
  const validateOtp = (otp: string): IError | null => {
    if (otp.trim() === '') {
      return { field: 'otp', message: 'Please enter an OTP.' };
    } else if (!/^\d+$/.test(otp)) {
      return { field: 'otp', message: 'OTP must be numeric.' };
    }
    return null;
  };

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const errors: IError[] = [];

    // Validate email/username/phone
    const contactInfoError = validateContactInfo(
      values.contact || '',
    );
    if (contactInfoError) {
      errors.push(contactInfoError);
    }

    // Validate OTP
    const otpError = validateOtp(values.otp);
    if (otpError) {
      errors.push(otpError);
    }

    // Update form errors and show toast notifications
    setFormErrors(errors);

    if (errors.length > 0) {
      errors.forEach((error) => {
        toast.error(error.message, {
          position: "bottom-right",
          autoClose: 3000,
        });
      });
      return;
    }

    setIsProcessing(true);

    // Payload preparation
    let payload: { email?: string; username?: string; phone?: string; otp: string } = {
      otp: values.otp,
    };

    // Use the correct field based on the input
    if (values.contact && /\S+@\S+\.\S+/.test(values.contact)) {
      payload.email = values.contact; // Email case
    } else if (values.contact && /^[0-9]{10}$/.test(values.contact)) {
      payload.phone = values.contact; // Phone case
    }

    // Dispatch action to confirm account
    try {
      if (errors.length === 0) {
        await dispatch(confirmAccount(payload)).unwrap();
        // ✅ Reset only on success
        setValues(confirmAccountFormProps);
      }
    } catch (error: any) {
      const message =
        error?.data?.message ||
        error?.message ||
        "OTP verification failed. Please check the email and OTP and try again.";
      toast.error(message, { position: "bottom-right", autoClose: 3500 });
    } finally {
      setIsProcessing(false);
    }
  };

  // Effect hook to dispatch action when form is submitted and there are no errors
  useEffect(() => {
    if (account.statusCode === 201) {
      setIsProcessing(false);
      setValues(confirmAccountFormProps);
      localStorage.removeItem('signup_email');
      toast.success(account.message || "Your account has been verified. Please sign in.", {
        position: "bottom-right",
        autoClose: 3500,
        toastId: "account-verification-success",
      });
      navigate('/auth/sign-in');
      dispatch(resetAuth());
    }
  }, [account.statusCode, account.message, navigate, dispatch]);

  useEffect(() => {
    const stored = localStorage.getItem('signup_email');
    if (stored) {
      const parsed = JSON.parse(stored);
      const currentTime = new Date().getTime();

      if (parsed.expiry > currentTime) {
        // Email still valid
        setValues((prev) => ({
          ...prev,
          contact: parsed.email
        }));
      } else {
        // Expired
        localStorage.removeItem('signup_email');
      }
    }
  }, []);

  // Handle input changes
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  return {
    values,
    formErrors,
    handleChange,
    handleSubmit,
    isProcessing,
  };
};
// import { useEffect, useState } from "react";
// import { IConfirmAccountsFormProps } from "../../interfaces/account/signup";
// import { toast } from "react-toastify";
// import { IError } from "../../interfaces/user/errors";
// import { AppDispatch } from "../../store";
// import { useDispatch, useSelector } from "react-redux";
// import { confirmAccount } from "../../data-access/apis/authentication/auth";
// import { useNavigate } from "react-router-dom";
// import { resetAuth } from "../../stores/auth-slice";

// // Default form values
// const confirmAccountFormProps: IConfirmAccountsFormProps = {
//   contact: '',
//   otp: '',
//   phone: '',
// };

// export const ConfirmAccountHelper = () => {
//   const [values, setValues] = useState<IConfirmAccountsFormProps>(confirmAccountFormProps);
//   const [formErrors, setFormErrors] = useState<IError[]>([]);
//   const [isProcessing, setIsProcessing] = useState<boolean>(false);
//   const account = useSelector((state: any) => state.auth);
//   const dispatch: AppDispatch = useDispatch();
//   const navigate = useNavigate(); // Initialize navigate from useNavigate


//   // Helper function to validate contact information (email, username, or phone)
//   const validateContactInfo = (contact: string): IError | null => {
//     const isEmailValid = /\S+@\S+\.\S+/.test(contact);
//     const isPhoneValid = /^[0-9]{10}$/.test(contact);

//     if (contact.trim() === '') {
//       return { field: 'contact', message: 'Please provide either email, username, or phone number.' };
//     } else if (isEmailValid || isPhoneValid) {
//       // No error if either valid email or phone
//       return null;
//     } else {
//       return { field: 'contact', message: 'Please enter a valid email address or phone number.' };
//     }
//   };

//   // Helper function to validate OTP
//   const validateOtp = (otp: string): IError | null => {
//     if (otp.trim() === '') {
//       return { field: 'otp', message: 'Please enter an OTP.' };
//     } else if (!/^\d+$/.test(otp)) {
//       return { field: 'otp', message: 'OTP must be numeric.' };
//     }
//     return null;
//   };

//   // Handle form submission
//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();

//     const errors: IError[] = [];

//     // Validate email/username/phone
//     const contactInfoError = validateContactInfo(
//       values.contact || '',
//     );
//     if (contactInfoError) {
//       errors.push(contactInfoError);
//     }

//     // Validate OTP
//     const otpError = validateOtp(values.otp);
//     if (otpError) {
//       errors.push(otpError);
//     }

//     // Update form errors and show toast notifications
//     setFormErrors(errors);

//     if (errors.length > 0) {
//       errors.forEach((error) => {
//         toast.error(error.message, {
//           position: "bottom-right",
//           autoClose: 3000,
//         });
//       });
//       return;
//     }

//     setIsProcessing(true);

//     // Payload preparation
//     let payload: { email?: string; username?: string; phone?: string; otp: string } = {
//       otp: values.otp,
//     };

//     // Use the correct field based on the input
//     if (values.contact && /\S+@\S+\.\S+/.test(values.contact)) {
//       payload.email = values.contact; // Email case
//     } else if (values.contact && /^[0-9]{10}$/.test(values.contact)) {
//       payload.phone = values.contact; // Phone case
//     }

//     // Dispatch action to confirm account
//     try {
//       if (errors.length === 0) {
//         await dispatch(confirmAccount(payload)).unwrap();
//       }
//     } catch (error: any) {
//     } finally {
//       setIsProcessing(false);
//       setValues(confirmAccountFormProps); // Reset form after submission
//     }
//   };

//   // Effect hook to dispatch action when form is submitted and there are no errors
//   useEffect(() => {
//     if (account.statusCode === 201) {
//       setIsProcessing(false);
//       setValues(confirmAccountFormProps);  // Reset the form fields
//       navigate('/auth/sign-in');
//       dispatch(resetAuth());
//     }
//   }, [account.statusCode, navigate, dispatch])

//   useEffect(() => {
//     const stored = localStorage.getItem('signup_email');
//     if (stored) {
//       const parsed = JSON.parse(stored);
//       const currentTime = new Date().getTime();

//       if (parsed.expiry > currentTime) {
//         // Email still valid
//         setValues((prev) => ({
//           ...prev,
//           contact: parsed.email
//         }));
//       } else {
//         // Expired
//         localStorage.removeItem('signup_email');
//       }
//     }
//   }, []);

//   // Handle input changes
//   const handleChange = (e: any) => {
//     const { name, value } = e.target;
//     setValues((prevValues) => ({
//       ...prevValues,
//       [name]: value,
//     }));
//   };

//   return {
//     values,
//     formErrors,
//     handleChange,
//     handleSubmit,
//     isProcessing,
//   };
// };
